const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.19 17.78L12.41 11H14c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.25 0-.51.1-.7.29S9 9.74 9 10v4c0 .55.45 1 1 1s1-.45 1-1v-1.59l6.78 6.78a.996.996 0 101.41-1.41z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 4c0-2.21-1.79-4-4-4H4C1.79 0 0 1.79 0 4v12c0 2.21 1.79 4 4 4 0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm2 16c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2h7c.55 0 1-.45 1-1s-.45-1-1-1H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v9c0 .55.45 1 1 1s1-.45 1-1V6c1.1 0 2 .9 2 2z"
});

const SvgMove = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/move.a16ad1ab.svg";
export { ForwardRef as ReactComponent };